module.exports = __webpack_public_path__ + "static/img/health.92e2f1b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/health.webp
// module id = g/S8
// module chunks = 68